import React from 'react';
import { connect } from 'react-redux';

import PlusIcon from '@material-ui/icons/PlaylistAdd';

import HDrawer from '../../../common/HDrawer';
import SupersetCreate from '../SupersetCreate';
import * as DesignerState from '../../../../state/reducer/designer/designer';

import Console from '../../../../lib/debug';

export class SupersetCreateDrawerClass extends React.Component {
    handleSave = title => {
        DesignerState.saveBlockAsSuperset(this.props.block, title);
    };

    handleClose = () => {
        const isOpen = false;
        DesignerState.toggleSupersetSaveDialog(this.props.block, isOpen);
    };

    render() {
        Console.render('SupersetCreateDrawer');

        return (
            <HDrawer
                open={this.props.isOpen}
                onClose={this.handleClose}
                title="Save Superset to Library"
                subTitle=""
                icon={<PlusIcon />}
            >
                <SupersetCreate
                    block={this.props.block || {}}
                    isSidenav={true}
                    onClose={this.handleClose}
                    onSave={this.handleSave}
                />
            </HDrawer>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let block = state.calendar.uiTree.block;
    if (
        block &&
        state.calendar.blockTree &&
        state.calendar.blockTree[block.key]
    ) {
        block.exercises = state.calendar.blockTree[block.key].exercises;
        block.exerciseKeys = state.calendar.blockTree[block.key].exerciseKeys;
    }
    return {
        isOpen: !!state.calendar.uiTree.supersetDialog,
        block: block,
        ...ownProps
    };
};

export default connect(mapStateToProps)(SupersetCreateDrawerClass);
